import { motion } from "framer-motion";
import { Star, Heart, Brain, Trophy } from "lucide-react";

const benefits = [
  {
    icon: Star,
    title: "Build Confidence",
    description: "Watch your child's self-esteem soar as they master new skills"
  },
  {
    icon: Heart,
    title: "Physical Fitness",
    description: "Develop strength, flexibility, and coordination in a fun way"
  },
  {
    icon: Brain,
    title: "Mental Growth",
    description: "Improve focus, discipline, and problem-solving abilities"
  },
  {
    icon: Trophy,
    title: "Achievement",
    description: "Set and reach personal goals through structured progression"
  }
];

export const Benefits = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-purple-50 to-white">
      <div className="container mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-4xl font-bold text-center text-primary mb-16"
        >
          Benefits of Gymnastics
        </motion.h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="w-16 h-16 mx-auto mb-6 bg-primary/10 rounded-full flex items-center justify-center">
                <benefit.icon className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                {benefit.title}
              </h3>
              <p className="text-gray-600">{benefit.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};